export default {
  MasterK1File: 'Master K-1 File',
  ProcessedK1File: 'Individual K-1 File'
}
